import React from "react";
import TopView from "../top/top.view.jsx";
import HeaderView from "../header/header.view.jsx";
import FooterView from "../footer/footer.view.jsx";
import LoadingWithApiQueue from "../loading/loading-with-queue.view";

import "./layout.scss";

export default class LayoutDesktopView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bodyHeight: null,
    };
  }

  render() {
    return (
      <div className="layout-container">
        <TopView />
        <HeaderView match={this.props.match} />
        <div style={this.state.bodyHeight}>{this.props.children}</div>
        <LoadingWithApiQueue />
        <div className="cb"></div>
        <FooterView />
      </div>
    );
  }
}
